type Props = {
  width?: string;
  height?: string;
  strokeColor?: string;
};
const FillIcon = (props: Props) => {
  const { width = '12', height = '12', strokeColor = '#E5E5E5' } = props;
  return (
    <svg
      fill={strokeColor}
      width={width}
      height={height}
      viewBox="0 0 32 32"
      id="icon"
      xmlns="http://www.w3.org/2000/svg"
    >
      <polygon points="22 16 24 16 24 8 16 8 16 10 22 10 22 16" />
      <polygon points="8 24 16 24 16 22 10 22 10 16 8 16 8 24" />
      <path d="M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H26a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,26,28ZM6,6V26H26.0012L26,6Z" />
    </svg>
  );
};

export default FillIcon;
